import { parseFilterRecordByKey } from "./filter";

export function calculateRemainingProgress(setting, used, segments = 23) {
  const safeSetting = Number(setting);
  const safeUsed = Math.max(0, Number(used) || 0);
  const safeSegments = Math.max(1, Number(segments) || 23);

  if (!Number.isFinite(safeSetting) || safeSetting <= 0) {
    return {
      consumed: 0,
      remaining: 0,
      remainingPercent: 0,
      greenSegments: 0,
      graySegments: safeSegments
    };
  }

  const consumed = Math.min(safeSetting, safeUsed);
  const remaining = Math.max(0, safeSetting - consumed);
  const remainingPercent = Math.round((remaining / safeSetting) * 100);
  const greenSegments = Math.max(
    0,
    Math.min(safeSegments, Math.round((remaining / safeSetting) * safeSegments))
  );

  return {
    consumed,
    remaining,
    remainingPercent,
    greenSegments,
    graySegments: safeSegments - greenSegments
  };
}

function withProgress(record) {
  if (!record) {
    return null;
  }

  return Object.assign({}, record, {
    flowProgress: calculateRemainingProgress(record.settingFlow, record.usedFlow),
    dayProgress: calculateRemainingProgress(record.settingDays, record.usedDays)
  });
}

export function parseConsumable(protocol, key) {
  return withProgress(parseFilterRecordByKey(protocol, key));
}
